export const googleCaptcha = (sitekey, isLoaded = false, action = 'enquiry') => {
  let loaded = isLoaded;

  let challengeCallback = null;

  const execute = () => {
    if (!window.grecaptcha || !window.grecaptcha.enterprise) {
      throw new Error('grecaptcha enterprise is not loaded');
    }
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(sitekey, { action }).then((token) => {
        if (challengeCallback) {
          challengeCallback(token);
        }
      });
    });
  };

  const loadAndExecute = () => {
    $.getScript(`https://www.google.com/recaptcha/enterprise.js?render=${sitekey}`).done(() => {
      loaded = true;
      execute();
    });
  };

  const challenge = (callback) => {
    challengeCallback = callback;

    if (!loaded) {
      loadAndExecute();
      return;
    }

    execute();
  };

  return {
    challenge,
  };
};
